<div
    class="relative flex flex-col justify-start items-center gap-4 bg-p-content-hover-background font-inter w-40 p-3 pointer-events-auto">
    @if (showCloseButton) {
        <p-button
            [buttonProps]="{ autofocus: false }"
            (click)="onClosePopover.emit($event)"
            size="small"
            severity="secondary"
            [outlined]="true"
            icon="pi pi-times"
            class="absolute top-0 right-0" />
    }
    <div class="flex flex-col justify-start items-center gap-2">
        <div class="flex flex-col justify-start items-center gap-1">
            <fm-avatar
                [sizePx]="64"
                [isSaved]="data.partner?.saved"
                [avatarLocation]="data.partner?.profilePhoto" />
            <div
                class="font-semibold text-14 text-color leading-[17px] text-center text-ellipsis overflow-hidden"
                >{{ data.partner?.displayName }}</div
            >
        </div>
        <p-button
            [buttonProps]="{ autofocus: false }"
            (click)="onViewProfileSelected.next($event)"
            [fmSendProfileToDynamicPanel]="data.partner.profileSlug"
            [fmSendProfileToDynamicPanelSource]="'Profile Preview'"
            size="small"
            label="View profile"
            [outlined]="true"
            severity="primary" />
        <div
            class="flex flex-col justify-center items-center text-12 text-muted-color font-medium leading-[15px] w-full text-center">
            <div class="flex flex-row items-center">
                <div>
                    {{ data.partner?.completedSessions }}
                    {{ data.partner?.completedSessions == 1 ? 'session' : 'sessions' }}
                </div>
                @if (data.partner?.ambassadorSessionsAttended) {
                    &nbsp;·&nbsp;<fm-ambassador-sessions-badge
                        [tag]="false"
                        [ambassadorSessionsAttended]="data.partner?.ambassadorSessionsAttended" />
                }
            </div>
            @if (data.partner?.isHost && featureCheckService.groupMeetingsEnabledSig()) {
                <div class="flex w-full justify-center">
                    <fm-host-badge size="small" [isHost]="!!data.partner?.isHost" />
                </div>
            }
            <div>{{ data.partner?.timezone }}</div>
        </div>

        @if (sharedGroups.length > 0) {
            <div class="flex flex-row justify-center items-center gap-0.5">
                @for (group of sharedGroups; track group.groupId; let i = $index) {
                    @if (i < 2) {
                        <!-- Max 2 logos -->
                        <fm-group-avatar [avatarLocation]="group.groupLogo" />
                    }
                }
                @if (sharedGroups.length > 2) {
                    <div
                        class="bg-p-content-background text-muted-color text-10 font-medium h-6 w-6 rounded flex item-center justify-center leading-[24px] text-center"
                        >+{{ sharedGroups.length - 2 }}</div
                    >
                }
            </div>
        }
    </div>
</div>
